import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {UserApiService} from '../api/user-api.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {passwordMatchValidator} from './password-validator';
import {API_URL, MembershipDisplayNames, MembershipType} from '../constants';
import {ToastrService} from 'ngx-toastr';
import {ChapterApiService} from '../api/chapter-api.service';
import {CommitteeService} from '../api/committee-api.service';
import {AuthService} from '../api/auth.service';
import {SpinnerService} from '../shared/services/spinner.service';
import {User} from '../models/user.model';
import {finalize} from 'rxjs';
import {EmailApiService} from '../api/email-api.service';
import {PaymentApiService} from '../api/payment-api.service';
import {NotificationApiService} from '../api/notification-api.service';
import {ChapterNotification} from '../models/notification.model';
import { FormArray } from '@angular/forms';

declare var Stripe: any;


@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.css',
})
export class ProfileComponent implements AfterViewInit {
    @ViewChild('collapseFour') collapseFour!: ElementRef;
    @ViewChild('collapseOne') collapseOne!: ElementRef;
    private apiUrl = `${API_URL}` + 'users';
    isProfileUpdated: boolean = false;
    isPasswordUpdated: boolean = false;
    isPhotoUpdated: boolean = false;
    @ViewChild('canvas', {static: false}) canvas!: ElementRef<HTMLCanvasElement>;
    userChapter: String | '' |undefined;
    chapterNotifications: ChapterNotification[] = [];

    profileForm: FormGroup;
    passwordForm: FormGroup;
    profileError = false;
    passwordError = false; // Flag for displaying error message
    user!: User;
    userid: any;
    selectedFile: File | null = null;
    uploadedImageUrl: string | null = null;
    userType = 'Non Member';
    showUserSearch = false;
    passwordData = {
        password: '',
    };
    profileData = {
        firstname: '',
        lastname: '',
        companyName: '',
        resetPassword: false,
        phone: '',
        email: '',
        addressLine2: '',
        city: '',
        addressLine1: '',
        country: '',
        state: '',
        zipCode: '',
        spouseName: '',
        spouseEmailId: '',
        spousePhoneNumber: '',
        kidsName: '',
        kidDetails: [] as any[],
        aboutMe: '',
        password: '',
        sex: '',
        maritalStatus: '',
        userGotra: '',
        userSubCast: '',
        spouseGotra: '',
        spouseSubCast: '',
        reference1: '',
        reference2: '',
        applicationStatus: '',
        userBriefDesc: '',
        spouseBriefDesc: '',
        chapterAffiliation: '',
        photouri: '',
        tnc: '',
    };
    chapterList: any;

    constructor(
        private userApiService: UserApiService,
        private toastr: ToastrService,
        private router: Router,
        private fb: FormBuilder,
        private chapterApiService: ChapterApiService,
        private committeeService: CommitteeService,
        private authService: AuthService,
        private spinner: SpinnerService,
        private paymentApi: PaymentApiService,
        private emailApi: EmailApiService,
        private notificationApiService: NotificationApiService
    ) {
        this.passwordForm = this.fb.group(
            {
                password: ['', [Validators.required, Validators.minLength(6)]],
                verifypassword: ['', [Validators.required, Validators.minLength(6)]],
            },
            {validators: passwordMatchValidator()}
        );
        this.profileForm = this.fb.group(
            {
                firstname: ['', [Validators.required]], // firstname field
                lastname: ['', [Validators.required]],
                companyName: [''],
                phone: ['', [Validators.required]],
                email: ['', [Validators.required]],
                addressLine1: ['', [Validators.required]],
                addressLine2: [''],
                city: ['', [Validators.required]],
                state: ['', [Validators.required]], // Email field
                zipCode: ['', [Validators.required]],
                country: ['', [Validators.required]],
                spouseName: [''],
                spouseEmailId: [''],
                spousePhoneNumber: [''],
                kidsName: [''],
                kidDetails: this.fb.array([]),
                aboutMe: [''],
                password: ['',],
                verifypassword: ['',],
                sex: ['', [Validators.required]],
                maritalStatus: ['', [Validators.required]], // Password field
                userGotra: ['', [Validators.required]],
                userSubCast: ['', [Validators.required]],
                chapterAffiliation: ['', [Validators.required]],
                tnc: ['',],
            },
            {validators: passwordMatchValidator()}
        );

        this.callUserChapterWhileLoading();
        //check refreshtoken and call that function
        authService.$refreshTokenReceived.subscribe((response: any) => {
                this.callUserChapterWhileLoading(); // Call the function to refresh data
            }
        );

    }

// Change this:
// createKidForm() {


    callUserChapterWhileLoading() {
        this.userid = sessionStorage.getItem('userId');
        this.spinner.show(); // ✅ Show spinner at the beginning

        // Load chapter notifications for user
        this.loadChapterNotifications();

        this.userApiService.getData(this.userid).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe((data) => {
                this.user = data;
                this.profileData = data;
                // **********************************************
                // ✅ NEW: Populate the kidDetails FormArray
                // **********************************************
                this.kidDetails.clear(); // Clear existing controls just in case
                if (this.profileData.kidDetails && this.profileData.kidDetails.length > 0) {
                    this.profileData.kidDetails.forEach(kid => {
                        this.kidDetails.push(this.createKidForm(kid));
                    });
                }

                if (this.profileData.resetPassword) {
                    setTimeout(() => {
                        this.openChangePassword();
                    }, 0);
                }
                if (this.profileData.aboutMe == null || this.profileData.aboutMe == '' || this.profileData.aboutMe == undefined) {
                    this.profileData.aboutMe = 'Here is some initial content.'; // Or empty string

                }

                // this.uploadedImageUrl =
                // `${API_URL}` + 'profile/viewimage/' + this.userid + '/' + this.profileData.photouri;


                if (this.profileData.photouri && this.profileData.photouri !== 'null') {
                    const imageUrl = `${API_URL}profile/viewimage/${this.userid}/${this.profileData.photouri}`;
                    this.userApiService.getProfileImageAsBlob(imageUrl).subscribe(
                        (blob: Blob) => {
                            if (blob && blob.size > 0) {
                                if (this.uploadedImageUrl) {
                                    URL.revokeObjectURL(this.uploadedImageUrl);
                                }
                                this.uploadedImageUrl = URL.createObjectURL(blob); // use in <img [src]>
                            } else {
                                console.error('Blob is empty or invalid.');
                            }
                        },
                        (error) => {
                            console.error('Failed to load image preview:', error);
                        }
                    );
                }


                if (data.memberType != null) {
                    this.userType = data.memberType;
                }

                this.chapterApiService.getChapterData(this.profileData.chapterAffiliation).subscribe(
                    (response) => {
                        this.userChapter = response.name;
                        this.userType = this.userType;// + ', ' + response.name;

                        // this.viewCommitteesByChapterId(this.chapter.id);

                        this.committeeService.getCommitteesByChapterId(this.profileData.chapterAffiliation).subscribe({
                            next: (data) => {
                                // this.committeeMembers = data;
                                for (let i = 0; i < data.length; i++) {
                                    if (data[i].userId == this.user.id) {
                                        // this.user.title = data[i].title;
                                        this.userType = data[i].title;// + ', ' + response.name;


                                    }
                                }
                            },
                            error: (err) => {
                                console.error('Error fetching committee:', err);
                            },
                        });

                    },
                    (error) => {
                        // Handle login error (invalid credentials, server error, etc.)
                        console.error('Failed to load chapters', error);

                    }
                );


            },
            (error) => {
                console.error('Error in calling api');
            }
        );


        this.chapterApiService.getData().subscribe(
            (response) => {

                this.chapterList = response;
                ;
            },
            (error) => {
                // Handle login error (invalid credentials, server error, etc.)
                console.error('Failed to load chapters', error);

            }
        );


    }


    toggleProfileUpdated() {
        this.isProfileUpdated = false;
    }

    togglePasswordUpdated() {
        this.isProfileUpdated = false;
    }

    updateProfile(): void {
        // Call the login API
        console.log('Profile called');
        if (this.profileForm.valid) {
            this.spinner.show(); // ✅ Show spinner at the beginning
            this.profileData.kidDetails = this.kidDetails.value;
            this.userApiService
                .updateProfile(this.userid, this.profileData).pipe(
                finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
            ).subscribe(
                (response) => {
                    this.isProfileUpdated = true;
                    // Handle successful login (redirect, set session, etc.)
                    //this.router.navigate(['/profile'], { state: { response } });
                    this.profileError = false; // Reset the error flag
                    this.toastr.success('Profile updated successfully!', 'Success');
                },
                (error) => {
                    // Handle login error (invalid credentials, server error, etc.)
                    console.error('Profile Update failed', error);
                    this.profileError = true; // Display error message
                    this.toastr.error('' + error.error, 'Submission Failed');
                }
            );
        } else {
            this.profileForm.markAllAsTouched();
            this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
        }
    }

    updatePassword(): void {
        // Call the login API
        console.log('Password update called');
        if (this.passwordForm.valid) {
            this.spinner.show();
            this.userApiService
                .updatePassword(this.userid, this.passwordData)
                .pipe(
                    finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
                ).subscribe(
                (response) => {
                    this.isPasswordUpdated = true;

                    this.toastr.success('Password updated successfully!', 'Success');
                    this.passwordError = false; // Reset the error flag
                },
                (error) => {
                    console.error('Password Update failed', error);
                    this.toastr.error('Password Update failed.', 'Submission Failed');
                    this.passwordError = true; // Display error message
                }
            );
        } else {
            this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
        }
    }


    ngOnInit() {
        if (this.user) {
            this.user.aboutMe = this.profileData.aboutMe || 'Here is some initial content.';
        }
    }

    openUserSearch(): void {
        this.showUserSearch = true;
    }

    ngAfterViewInit() {
        if (this.profileData.resetPassword) {
            setTimeout(() => this.openChangePassword(), 0);
        }
    }

    /*openChangePassword() {
      const collapseElementFour = this.collapseFour.nativeElement;
      const collapseElementOne = this.collapseOne.nativeElement;
      if (!collapseElementFour.classList.contains('show')) {
        // Use Bootstrap Collapse JS API
        const bootstrapCollapse = new bootstrap.Collapse(collapseElementFour, { toggle: true });
        bootstrapCollapse.show(); // ensures it opens
      }
      if (collapseElementOne.classList.contains('show')) {
        // Use Bootstrap Collapse JS API
        const bootstrapCollapse = new bootstrap.Collapse(collapseElementOne, { toggle: true });
        bootstrapCollapse.hide(); // ensures it closes
      }
    }
  */
    openChangePassword() {
        const collapseElementFour = this.collapseFour.nativeElement;
        const collapseElementOne = this.collapseOne.nativeElement;

        // Open collapseFour
        if (!collapseElementFour.classList.contains('show')) {
            collapseElementFour.classList.add('show');
            collapseElementFour.style.height = collapseElementFour.scrollHeight + 'px';
        }

        // Close collapseOne
        if (collapseElementOne.classList.contains('show')) {
            collapseElementOne.style.height = collapseElementOne.scrollHeight + 'px'; // set current height
            requestAnimationFrame(() => { // allow DOM to update
                collapseElementOne.style.height = '0px';
            });
            collapseElementOne.classList.remove('show');
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            console.error("No file selected.");
            return;
        }

        const file = input.files[0];
        const maxWidth = 500; // Desired width

        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
            if (!e.target?.result) return;
            img.src = e.target.result as string;
        };

        reader.readAsDataURL(file);

        img.onload = () => {
            const scaleFactor = maxWidth / img.width;
            const newWidth = maxWidth;
            const newHeight = img.height * scaleFactor;

            const canvas = this.canvas.nativeElement;
            const ctx = canvas.getContext('2d');

            // Resize the canvas
            canvas.width = newWidth;
            canvas.height = newHeight;

            if (ctx) {
                // Draw the resized image
                ctx.drawImage(img, 0, 0, newWidth, newHeight);
            }

            // Convert the canvas to a Blob (or Base64)
            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        // Create a new file from the Blob
                        const resizedFile = new File([blob], file.name, {
                            type: file.type,
                            lastModified: Date.now(),
                        });

                        console.log("Resized File:", resizedFile);
                        // You can now upload `resizedFile` via a service
                    }
                },
                file.type,
                1 // Quality (1 = max quality for image/jpeg)
            );
        };
    }

    loadChapterNotifications(): void {
        if (!this.userid) return;
        this.notificationApiService.getForUser(this.userid).subscribe({
            next: (data) => this.chapterNotifications = data,
            error: (err) => console.error('Failed to load chapter notifications', err)
        });
    }

    dismissChapterNotification(notificationId: string): void {
        if (!this.userid) return;
        this.notificationApiService.dismiss(this.userid, notificationId).subscribe({
            next: () => {
                this.chapterNotifications = this.chapterNotifications.filter(
                    n => n.notificationId !== notificationId
                );
            },
            error: (err) => console.error('Failed to dismiss notification', err)
        });
    }

    markAsDeleted(notificationId: string): void {
        if (!this.user) return;

        this.userApiService.deleteUserNotification(this.user.id, notificationId).subscribe({
            next: () => {
                // Remove from UI immediately
                if (this.user && Array.isArray(this.user.userNotifications)) {
                    this.user.userNotifications = this.user.userNotifications.filter(n => n.userNotificationId !== notificationId);
                }
            },
            error: (err) => console.error('Failed to delete notification', err)
        });
    }

    // Change this:
// createKidForm() {

// To this:
    createKidForm(kidData: any = {}) { // Accept kidData with a default empty object
        return this.fb.group({
            kidDetailsId: [kidData.kidDetailsId || ''],
            firstName: [kidData.firstName || '', Validators.required], // Use existing data if present
            lastName: [kidData.lastName || '', Validators.required],
            sex: [kidData.sex || '', Validators.required],
            yearOfBirth: [kidData.yearOfBirth || ''],
            email: [kidData.email || '']
        });
    }
    addKid() {
        this.kidDetails.push(this.createKidForm());
    }

    removeKid(index: number) {
        this.kidDetails.removeAt(index);
    }

    get kidDetails(): FormArray {
        return this.profileForm.get('kidDetails') as FormArray;
    }
    get firstname() {
        return this.profileForm.get('firstname');
    }

    get lastname() {
        return this.profileForm.get('lastname');
    }

    get companyName() {
        return this.profileForm.get('companyName');
    }

    get phone() {
        return this.profileForm.get('phone');
    }

    get email() {
        return this.profileForm.get('email');
    }

    get addressLine2() {
        return this.profileForm.get('addressLine2');
    }

    get city() {
        return this.profileForm.get('city');
    }

    get addressLine1() {
        return this.profileForm.get('addressLine1');
    }

    get state() {
        return this.profileForm.get('state');
    }

    get zipCode() {
        return this.profileForm.get('zipCode');
    }

    get country() {
        return this.profileForm.get('country');
    }

    get password() {
        return this.passwordForm.get('password');
    }

    get verifypassword() {
        return this.profileForm.get('verifypassword');
    }

    get spouseName() {
        return this.profileForm.get('spouseName');
    }

    get spouseEmailId() {
        return this.profileForm.get('spouseEmailId');
    }

    get spousePhoneNumber() {
        return this.profileForm.get('spousePhoneNumber');
    }

    get kidsName() {
        return this.profileForm.get('kidsName');
    }

    get aboutMe() {
        return this.profileForm.get('aboutMe');
    }

    get sex() {
        return this.profileForm.get('sex');
    }

    get maritalStatus() {
        return this.profileForm.get('maritalStatus');
    }

    get userGotra() {
        return this.profileForm.get('userGotra');
    }

    get userSubCast() {
        return this.profileForm.get('userSubCast');
    }

    get spouseGotra() {
        return this.profileForm.get('spouseGotra');
    }

    get spouseSubCast() {
        return this.profileForm.get('spouseSubCast');
    }

    get reference1() {
        return this.profileForm.get('reference1');
    }

    get reference2() {
        return this.profileForm.get('reference2');
    }

    get applicationStatus() {
        return this.profileForm.get('applicationStatus');
    }

    get userBriefDesc() {
        return this.profileForm.get('userBriefDesc');
    }

    get spouseBriefDesc() {
        return this.profileForm.get('spouseBriefDesc');
    }

    get chapterAffiliation() {
        return this.profileForm.get('chapterAffiliation');
    }

    get tnc() {
        return this.profileForm.get('tnc');
    }

    //file handling
    // Handle file selection
    onFileSelect(event: any) {
        this.selectedFile = event.target.files[0];
        this.uploadImage();
    }

    // Called when user clicks PAY NOW button
    payNow() {
        sessionStorage.setItem('profileData', JSON.stringify(this.profileData));
        sessionStorage.setItem('pageid', '3');
        this.router.navigate(['/register']);
    }


    uploadImageOld(): void {
        // Call the login API
        console.log('upload image called');

        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            this.spinner.show(); // ✅ Show spinner before API call
            this.userApiService.uploadImage(this.userid, formData).pipe(
                finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
            ).subscribe(
                (response) => {
                    this.isPhotoUpdated = true;
                    this.profileError = false; // Reset the error flag
                    this.toastr.success('Profile Photo updated successfully!', 'Success');
                    if (this.profileData.photouri && this.profileData.photouri !== 'null') {
                        if (this.profileData.photouri && this.profileData.photouri !== 'null') {
                            const imageUrl = `${API_URL}profile/viewimage/${this.userid}/${this.profileData.photouri}`;
                            this.userApiService.getProfileImageAsBlob(imageUrl).subscribe(
                                (blob: Blob) => {
                                    if (blob && blob.size > 0) {
                                        if (this.uploadedImageUrl) {
                                            URL.revokeObjectURL(this.uploadedImageUrl);
                                        }
                                        this.uploadedImageUrl = URL.createObjectURL(blob); // Bind to <img [src]>
                                    } else {
                                        console.error('Blob is empty or invalid.');
                                    }
                                },
                                (error) => {
                                    console.error('Failed to load image preview:', error);
                                }
                            );
                        }
                    }

                },
                (error) => {
                    console.error('Image upload failed', error);
                    this.profileError = true; // Display error message
                }
            );
        }
    }


    uploadImage(): void {
        if (this.selectedFile) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const result = reader.result as string;
                const base64String = result.split(',')[1]; // Remove "data:image/jpeg;base64,"
                this.spinner.show(); // ✅ Show spinner before API call
                this.userApiService.uploadBase64Image(this.userid, base64String, this.selectedFile!.name).pipe(
                    finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
                ).subscribe(
                    (response) => {
                        this.isPhotoUpdated = true;
                        this.profileError = false;
                        this.toastr.success('Profile Photo updated successfully!', 'Success');

                        // Update profileData with the new photo URI if backend returns it
                        if (response && response.photouri) {
                            this.profileData.photouri = response.photouri;
                        }

                        if (this.profileData.photouri && this.profileData.photouri !== 'null') {
                            const imageUrl = `${API_URL}profile/viewimage/${this.userid}/${this.profileData.photouri}`;
                            this.userApiService.getProfileImageAsBlob(imageUrl).subscribe(
                                (blob: Blob) => {
                                    if (blob && blob.size > 0) {
                                        if (this.uploadedImageUrl) {
                                            URL.revokeObjectURL(this.uploadedImageUrl);
                                        }
                                        this.uploadedImageUrl = URL.createObjectURL(blob); // Bind to <img [src]>
                                    } else {
                                        console.error('Blob is empty or invalid.');
                                    }
                                },
                                (error) => {
                                    console.error('Failed to load image preview:', error);
                                }
                            );
                        }
                    },
                    (error) => {
                        console.error('Image upload failed', error);
                        this.profileError = true;
                        this.toastr.error('Image upload failed.', 'Error');
                    }
                );
            };

            reader.readAsDataURL(this.selectedFile);
        }
    }

    getMembershipLabel(type: string | undefined): string {
        if (!type) return 'N/A';
        // Cast the string from JSON to the Enum type to get the friendly name
        return MembershipDisplayNames[type as MembershipType] || type;
    }
}
